angular.module("vgresiduos").controller("CollectionRequestDisposalCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/destinacao/nova`);
		};
	}
]);
